import { joinURL } from "ufo";

export function getImage(src: string) {
	const runtimeConfig = useRuntimeConfig();
	return {
		url: joinURL(runtimeConfig.public.mediaDomain, src),
	};
}
